import React from 'react';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import { message } from 'antd';
import { DeleteButton } from 'components/button';
import { useLoading } from 'hooks';
import { DELETE_ANNUAL_REPORT } from 'gql/annualReports';

const DeleteAnnualReportButton = ({ id, actionRef }) => {
  const [deleteAnnualReport, { loading }] = useMutation(DELETE_ANNUAL_REPORT, {
    onCompleted: () => {
      message.success('Annual report deleted successfully');
    },
    onError: () => {},
  });
  useLoading(loading);

  const onOk = () => {
    deleteAnnualReport({
      variables: {
        id,
      },
    });
    actionRef.current.reload();
  };

  return (
    <DeleteButton
      onOk={onOk}
      content="Do you want to delete this annual report?"
    />
  );
};

DeleteAnnualReportButton.propTypes = {
  id: PropTypes.string.isRequired,
};

export default DeleteAnnualReportButton;
